<template>
    <div class="footer">
        <div class="title">
            <img class="logo" src="../assets/logo-white.png" alt="">
            <div class="list-item-title-warp">
                <div class="list-item-title">关于我们</div>
                <div class="list-item-title">业务案例</div>
                <div class="list-item-title">员工发展</div>
                <router-link tag="div" to="/news" class="list-item-title" style="cursor: pointer;">新闻媒体</router-link>
            </div>
        </div>
        <div class="list">
            <div class="list-item">
                <router-link tag="span" to="/companyProfile" class="span-title">企业介绍</router-link>
                <router-link tag="span" to="/honorAndQualification" class="">荣誉资质</router-link>
                <!-- <router-link tag="span" to="/customerPartner" class="span-title">客户伙伴</router-link> -->
                <router-link tag="span" to="" class="span-title">企业文化</router-link>
                <router-link tag="span" to="/brandStory" class="">品牌故事</router-link>
                <router-link tag="span" to="/developmentHistory" class="">发展历程</router-link>
                <!-- <router-link tag="span" :to="{ path: '/Link', query: { index: 0 } }" class="">联系我们</router-link> -->
                <router-link tag="span" to="/linkUs" class="span-title">联系我们</router-link>
            </div>
            <div class="list-item">
                <router-link tag="span" to="Case?index=0" class="span-title">门窗工程</router-link>
                <router-link tag="span" to="Case?index=1" class="span-title">幕墙工程</router-link>
                <router-link tag="span" to="Case?index=2" class="span-title">装饰装修</router-link>
                <!-- <router-link tag="span" to="" class="span-title">智能门窗</router-link> -->
            </div>
            <div class="list-item">
                <router-link tag="span" to="choeseTanjian" class="span-title">为什么选择探见</router-link>
                <!-- <router-link tag="span" :to="{ path: '/joinTanjian', }" class="">加入探见</router-link> -->
                <router-link tag="span" to="/workInTanjian" class="span-title">工作在探见</router-link>
                <router-link tag="span" to="/joinUs" class="span-title">加入我们</router-link>

            </div>
            <div class="list-item">
                <!-- <router-link tag="span" to="/Case" class="title">服务及案例</router-link>
                <router-link tag="span" to="/CoreBusiness" class="">服务领域</router-link>
                <router-link tag="span" to="/Case" class="">精品案例</router-link> -->
            </div>
        </div>
        <!-- <div class="list">
            <div class="list-item">
                <router-link tag="span" to="/WalkInto" class="title">关于探见</router-link>
                <router-link tag="span" :to="{ path: '/WalkInto', query: { index: 0 } }" class="">公司介绍</router-link>
                <router-link tag="span" :to="{ path: '/WalkInto', query: { index: 2 } }" class="">资质荣誉</router-link>
                <router-link tag="span" :to="{ path: '/WalkInto', query: { index: 3 } }" class="">企业文化</router-link>
                <router-link tag="span" :to="{ path: '/Link', query: { index: 0 } }" class="">联系我们</router-link>
            </div>
            <div class="list-item">
                <router-link tag="span" to="/News" class="title">新闻中心</router-link>
                <router-link tag="span" :to="{ path: '/News', query: { index: 0 } }" class="">公司新闻</router-link>
                <router-link tag="span" :to="{ path: '/News', query: { index: 1 } }" class="">企业动态</router-link>
            </div>
            <div class="list-item">
                <router-link tag="span" to="/Case" class="title">服务及案例</router-link>
                <router-link tag="span" to="/CoreBusiness" class="">服务领域</router-link>
                <router-link tag="span" to="/Case" class="">精品案例</router-link>
            </div>
            <div class="list-item">
                <router-link tag="span" to="/Link" class="title">加入我们</router-link>
                <router-link tag="span" :to="{ path: '/choeseTanjian', }" class="">选择探见</router-link>
                <router-link tag="span" :to="{ path: '/joinTanjian', }" class="">加入探见</router-link>
                <router-link tag="span" :to="{ path: '/workInTanjian', }" class="">工作在探见</router-link>
            </div>
        </div> -->
        <!-- <div class="text" style="margin:15px;line-height: 2em;">
            <p>Copyright © 上海探见智能家居有限公司版权所有</p>
            <p><a href="https://beian.miit.gov.cn/#/Integrated/index" style="text-decoration:none; "
                    target="_blank">备案号：沪ICP备2021032261号-1</router-link></p>
        </div> -->
        <div class="beian">
            <span>©Shanghai TJI Smart Home Co.,Ltd</span>
            <span><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备2021032261号-4</a></span>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    background-color: rgb(40, 40, 40);

    .title {
        padding: 0px 160px;
        height: 48px;
        width: 100%;
        display: flex;
        align-items: center;
        background-color: rgb(34, 34, 34);
        font-family: 'BoldFont';

        .logo {
            margin-right: 106px;
            // margin: 0 106px 0 160px;
            width: 127px;
        }

        .list-item-title-warp {
            width: 100%;
            // width: calc(100% - 500px);
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .list-item-title {
                text-align: right;
                // width: 360px;
                width: 25%;
                font-size: 18px;
                color: #fff;
            }
        }
    }

    .list {
        // width: calc(100% - 500px);
        width: 100%;
        padding: 0 160px 0 396px;
        // margin: 30px 0 30px 230px;
        display: flex;

        .list-item {
            // flex: 1;
            width: 337px;
            display: flex;
            flex-direction: column;
            // align-items: center;

            span {
                display: block;
                font-size: 12px;
                color: #fff;
                letter-spacing: 2px;
                margin-bottom: 6px;
                cursor: pointer;
                text-align: right;
            }

            .span-title {
                font-size: 16px;
                font-weight: bold;
                background-color: rgb(40, 40, 40);
                color: rgba(255, 255, 255, 0.8);
                margin-top: 20px;
                font-family: 'BoldFont';
            }
        }
    }


    .beian {
        width: calc(100% - 320px);
        margin: 0 auto;
        font-size: 12px;
        color: #fff;
        margin: 60px auto 0;
        border-top: 2px solid rgba(255, 255, 255, 0.2);
        padding: 10px 0 50px;

        a {
            color: #fff;
            font-size: 12px;
            text-decoration: none;
            margin-left: 20px;
        }
    }
}
</style>